import { SxProps, Theme } from '@mui/material/styles';

export const reportsStyles = {
  // Main container styles
  mainContainer: {
    // padding: 1,
    height: '100vh',
    color: 'white',
    backgroundColor: '#1a1a1a'
  } as SxProps<Theme>,

  // Title styles
  title: {
    mb: 1,
    color: 'white'
  } as SxProps<Theme>,

  // Filter header styles
  filterPaper: {
    p: 1.5,
    // mb: 1.5,
    backgroundColor: '#2d2d2d',
    backdropFilter: 'blur(10px)',
    border: '1px solid #404040',
    flexShrink: 0
  } as SxProps<Theme>,

  filterContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1,
    alignItems: 'center',
    borderRadius:'5px'
  } as SxProps<Theme>,

  // Form field containers
  dateTypeContainer: {
    flex: { xs: '1 1 100%', md: '0 0 calc(8% - 8px)' },
    minWidth: '120px'
  } as SxProps<Theme>,

  dateContainer: {
    flex: { xs: '1 1 100%', md: '0 0 calc(11.66% - 8px)' },
    minWidth: '100px'
  } as SxProps<Theme>,

  carContainer: {
    flex: { xs: '1 1 100%', md: '0 0 calc(11.66% - 8px)' },
    minWidth: '110px'
  } as SxProps<Theme>,

  statusContainer: {
    flex: { xs: '1 1 100%', md: '0 0 calc(17% - 8px)' },
    minWidth: '65px'
  } as SxProps<Theme>,

  leadSourceContainer: {
    flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)', md: '0 0 calc(12% - 8px)' },
    minWidth: '110px'
  } as SxProps<Theme>,

  searchButtonContainer: {
    flex: { xs: '1 1 100%', md: '0 0 calc(8.33% - 12px)' },
    minWidth: '90px'
  } as SxProps<Theme>,

  // Form control styles
  formControlLabel: {
    color: '#e0e0e0'
  } as SxProps<Theme>,

  selectField: {
    color: 'white',
    backgroundColor: '#404040',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#606060'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#2196F3'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#2196F3'
    },
    '& .MuiSelect-icon': {
      color: '#e0e0e0'
    },
    '& .MuiInputLabel-root': {
      color: '#e0e0e0'
    }
  } as SxProps<Theme>,

  // Date picker styles
  datePickerField: {
    backgroundColor: '#404040',
    '& .MuiInputLabel-root': { 
      color: '#e0e0e0',
      '&.Mui-focused': { color: '#2196F3' }
    },
    '& .MuiInputBase-input': { color: 'white' },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#606060'
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#2196F3'
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#2196F3'
    },
    '& .MuiSvgIcon-root': {
      color: '#e0e0e0'
    }
  } as SxProps<Theme>,

  // Status chips styles
  statusChipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0.25, // Reduced from 0.5
    maxHeight: '60px', // Add max height
    overflowY: 'auto', // Add scroll if needed
    alignItems: 'flex-start',
    // Left panel style scrollbar
    '&::-webkit-scrollbar': {
      width: '6px'
    },
    '&::-webkit-scrollbar-track': {
      background: '#121212'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#333',
      borderRadius: '3px'
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#555'
    },
    // Firefox scrollbar styling
    scrollbarWidth: 'thin',
    scrollbarColor: '#333 #121212'
  } as SxProps<Theme>,

  statusChip: {
    backgroundColor: '#404040',
    color: 'white',
    border: '1px solid #606060',
    height: '20px', // Make chips smaller
    fontSize: '0.65rem', // Smaller font size
    fontWeight: 500,
    borderRadius: '12px', // Make chips more rounded
    transition: 'all 0.2s ease-in-out', // Smooth transitions
    '& .MuiChip-label': {
      px: 0.5, // Reduce horizontal padding
      py: 0, // Remove vertical padding
      lineHeight: '18px'
    },
    '&:hover': {
      backgroundColor: '#505050',
      transform: 'translateY(-1px)', // Subtle hover animation
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)'
    }
  } as SxProps<Theme>,

  // Search button styles
  searchButton: {
    height: '40px',
    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    color: 'white',
    '&:hover': {
      background: 'linear-gradient(45deg, #1976D2 30%, #1CB5E0 90%)'
    }
  } as SxProps<Theme>,

  // Error alert styles
  errorAlert: {
    mb: 3,
    backgroundColor: '#d32f2f',
    color: 'white',
    flexShrink: 0
  } as SxProps<Theme>,


  // Trip status chip styles
  getStatusChipStyle: (status: string) => ({
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase' as const,
    ...(status === 'CONFIRMED' && {
      backgroundColor: 'rgba(76, 175, 80, 0.3)',
      color: '#81c784',
      border: '1px solid #4caf50'
    }),
    ...(status === 'CANCELLED' && {
      backgroundColor: 'rgba(244, 67, 54, 0.3)',
      color: '#e57373',
      border: '1px solid #f44336'
    }),
    ...(status === 'PENDING' && {
      backgroundColor: 'rgba(255, 193, 7, 0.3)',
      color: '#ffb74d',
      border: '1px solid #ffc107'
    }),
    ...(!['CONFIRMED', 'CANCELLED', 'PENDING'].includes(status) && {
      backgroundColor: 'rgba(158, 158, 158, 0.3)',
      color: '#bdbdbd',
      border: '1px solid #9e9e9e'
    })
  } as SxProps<Theme>),

  // DataGrid styles
  dataGridPaper: {
    backgroundColor: '#2d2d2d',
    backdropFilter: 'blur(10px)',
    width: '100%',
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    border: '1px solid #404040',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    
    // Global scrollbar override for this container
    '*': {
      '&::-webkit-scrollbar': {
        width: '9px !important',
        height: '4px !important',
      },
      '&::-webkit-scrollbar-track': {
        background: '#121212 !important',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#333 !important',
        borderRadius: '5px !important',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555 !important',
      },
    },
    
    // DataGrid header styles
    '& .datagrid-header': {
      backgroundColor: '#1a1a1a',
      color: 'white',
      fontWeight: 'bold',
      textTransform: 'uppercase',
      borderRight: '1px solid #404040',
    },
    
    // DataGrid root styles
    '& .MuiDataGrid-root': {
      backgroundColor: '#2d2d2d',
      color: 'white',
      border: 'none',
      height: '100%', // Use full container height
      display: 'flex',
      flexDirection: 'column',
      // Force scrollbar styles on root
      '&::-webkit-scrollbar': {
        width: '9px !important',
        height: '6px !important',
      },
      '&::-webkit-scrollbar-track': {
        background: '#121212 !important',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#333 !important',
        borderRadius: '3px !important',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555 !important',
      },
    },
    
    // DataGrid main container - ensure it takes available space minus footer
    '& .MuiDataGrid-main': {
      flex: 1,
      minHeight: 0, // Allow flexbox to shrink
      // Force scrollbar styles on main
      '&::-webkit-scrollbar': {
        width: '6px !important',
        height: '6px !important',
      },
      '&::-webkit-scrollbar-track': {
        background: '#121212 !important',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#333 !important',
        borderRadius: '3px !important',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555 !important',
      },
    },
    
    // DataGrid virtual scroller - constrain height to leave room for pagination
    '& .MuiDataGrid-virtualScroller': {
      flex: 1,
      // Force scrollbar styles on virtual scroller
      '&::-webkit-scrollbar': {
        width: '6px !important',
        height: '6px !important',
      },
      '&::-webkit-scrollbar-track': {
        background: '#121212 !important',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#333 !important',
        borderRadius: '3px !important',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555 !important',
      },
    },
    
    // DataGrid cell styles
    '& .MuiDataGrid-cell': {
      borderRight: '1px solid #404040',
      borderBottom: '1px solid #404040',
    },
    
    // DataGrid row styles
    '& .MuiDataGrid-row': {
      backgroundColor: '#2d2d2d',
      '&:hover': {
        backgroundColor: '#404040',
      },
    },
    
    // DataGrid footer styles - ensure it's always visible
    '& .MuiDataGrid-footerContainer': {
      backgroundColor: '#1a1a1a',
      color: 'white',
      borderTop: '1px solid #404040',
      position: 'sticky',
      bottom: 0,
      zIndex: 10,
      minHeight: '56px', // Ensure minimum height for pagination
      flexShrink: 0, // Prevent footer from shrinking
    },
    
    // DataGrid pagination styles - ensure visibility
    '& .MuiTablePagination-root': {
      color: 'white',
      '& .MuiTablePagination-displayedRows, & .MuiTablePagination-selectLabel': {
        color: 'white',
      },
      '& .MuiIconButton-root': {
        color: 'white',
        '&.Mui-disabled': {
          color: '#666',
        },
      },
      '& .MuiSelect-select': {
        color: 'white',
      },
    },
    
    // Ensure pagination controls are always accessible
    '& .MuiDataGrid-selectedRowCount': {
      color: 'white',
    },
    
    // DataGrid separator styles
    '& .MuiDataGrid-columnSeparator': {
      color: '#404040',
    },
    
    '& .MuiDataGrid-iconSeparator': {
      color: '#404040',
    },
    
    // DataGrid icon styles
    '& .MuiDataGrid-menuIcon': {
      color: 'white',
    },
    
    '& .MuiDataGrid-sortIcon': {
      color: 'white',
    },
    
    '& .MuiDataGrid-filterIcon': {
      color: 'white',
    },
    
    // DataGrid input styles
    '& .MuiInputBase-root': {
      color: 'white',
    },
    
    '& .MuiInputBase-input': {
      color: 'white',
    },
    
    // DataGrid quick filter styles
    '& .MuiDataGrid-toolbarQuickFilter': {
      '& .MuiInputBase-root': {
        backgroundColor: '#404040',
        color: 'white',
        borderRadius: '4px',
        '& .MuiInputBase-input': {
          color: 'white',
          '&::placeholder': {
            color: '#bdbdbd',
          },
        },
      },
    },
    
    // DataGrid checkbox styles
    '& .MuiCheckbox-root': {
      color: '#bdbdbd',
      '&.Mui-checked': {
        color: '#1976d2',
      },
    },
    
    // DataGrid menu styles
    '& .MuiMenu-paper': {
      backgroundColor: '#2d2d2d',
      color: 'white',
      border: '1px solid #404040',
    },
    
    // DataGrid select styles
    '& .MuiSelect-select': {
      color: 'white',
    },
    
    // DataGrid button styles
    '& .MuiButton-root': {
      color: 'white',
      '&:hover': {
        backgroundColor: '#404040',
      },
    },
    
    // DataGrid text field styles
    '& .MuiTextField-root': {
      '& .MuiOutlinedInput-root': {
        color: 'white',
        '& fieldset': {
          borderColor: '#404040',
        },
        '&:hover fieldset': {
          borderColor: '#606060',
        },
        '&.Mui-focused fieldset': {
          borderColor: '#1976d2',
        },
      },
      '& .MuiInputLabel-root': {
        color: '#bdbdbd',
        '&.Mui-focused': {
          color: '#1976d2',
        },
      },
    },
  } as SxProps<Theme>,

  // Custom toolbar styles (if you want to add custom toolbar later)
  customToolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px',
    backgroundColor: '#1a1a1a',
    borderBottom: '1px solid #404040',
    
    '& .toolbar-left': {
      display: 'flex',
      gap: '8px',
      alignItems: 'center',
    },
    
    '& .toolbar-right': {
      display: 'flex',
      gap: '8px',
      alignItems: 'center',
    },
    
    '& .MuiButton-root': {
      color: 'white',
      textTransform: 'none',
      '&:hover': {
        backgroundColor: '#404040',
      },
    },
  } as SxProps<Theme>,
};